import axios from "../../app/common/libs/http";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchReportingStats = createAsyncThunk(
    "reporting/getReportingStats", async (payload) => await axios.post(`${process.env.REACT_APP_APIURL}/insights/reportingStats`, payload)
);
export const fetchTranscriptsAverageCountHourly = createAsyncThunk(
    "reporting/getTranscriptsAverageCountHourly", async (payload) => await axios.post(`${process.env.REACT_APP_APIURL}/Report/transcriptsAverageCountHourly`, payload)
);
export const fetchTranscriptsCountDaily = createAsyncThunk(
    "reporting/getTranscriptsCountDaily", async (payload) => await axios.post(`${process.env.REACT_APP_APIURL}/Report/transcriptsCountDaily`, payload)
);

export const fetchWeeklyActivity = createAsyncThunk(
    "reporting/getWeeklyActivity", async (payload) => await axios.post(`${process.env.REACT_APP_APIURL}/Report/activity`, payload)
);
export const fetchChatRatingReport = createAsyncThunk(
    "reporting/getChatRatingReport", async (payload) => await axios.post(`${process.env.REACT_APP_APIURL}/Report/chatRatingReport`, payload)
);
export const fetchSchedulingReport = createAsyncThunk(
    "reporting/getSchedulingReport", async (payload) => await axios.post(`${process.env.REACT_APP_APIURL}/Report/schedulingReport`, payload)
);

export const sendDigestReportEmail = createAsyncThunk(
    "reporting/sendDigestReportEmail", async (payload) => await axios.post(`${process.env.REACT_APP_APIURL}/Report/sendWeeklyDigestReport`, payload)
);
